import type { ReactNode } from 'react';
import { EmptyState } from '@/kit/EmptyState';
import './EmptyRow.scss';

interface EmptyRowProps {
  /** Material icon, as for EmptyState. */
  icon?: string;
  /** One line saying what is missing ("No directors added yet"). */
  title: string;
  /** Optional second line saying what to do about it. */
  hint?: string;
  action?: ReactNode;
}

/**
 * The shared EmptyState, compact: for a table that sits inside a page with other content (one of several tables, or a section's list), where the
 * full-page padding of EmptyState would push the rest of the page away. Pass it as a DataTable `noDataMessage` once the list has loaded.
 */
export function EmptyRow(props: EmptyRowProps) {
  return (
    <div className="empty-row">
      <EmptyState {...props} />
    </div>
  );
}
